"use strict";

var cov_2oowdpgmh5 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/form/FormCheckbox.js";
  var hash = "42c2e77bb842e539034a8a084e34e5956208ca28";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/form/FormCheckbox.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 25,
          column: 4
        }
      },
      "1": {
        start: {
          line: 28,
          column: 0
        },
        end: {
          line: 42,
          column: 2
        }
      },
      "2": {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "3": {
        start: {
          line: 47,
          column: 15
        },
        end: {
          line: 49,
          column: 2
        }
      },
      "4": {
        start: {
          line: 47,
          column: 25
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "5": {
        start: {
          line: 51,
          column: 28
        },
        end: {
          line: 51,
          column: 69
        }
      }
    },
    fnMap: {
      "0": {
        name: "FormCheckboxComponent",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 30
          }
        },
        loc: {
          start: {
            line: 15,
            column: 3
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 47,
            column: 16
          }
        },
        loc: {
          start: {
            line: 47,
            column: 25
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 47
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "42c2e77bb842e539034a8a084e34e5956208ca28"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormCheckbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function FormCheckboxComponent(_ref) {
  var name = _ref.name,
      label = _ref.label,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  cov_2oowdpgmh5.f[0]++;
  cov_2oowdpgmh5.s[0]++;
  return _react.default.createElement(_core.FormControlLabel, {
    label: label,
    control: _react.default.createElement(_core.Checkbox, {
      color: "primary",
      value: "private",
      defaultChecked: checked,
      disabled: disabled,
      name: name,
      id: name + Math.random(),
      onChange: onChange
    })
  });
}

cov_2oowdpgmh5.s[1]++;
FormCheckboxComponent.propTypes = {
  classes: _propTypes.default.object.isRequired,

  /** The name/id of the field, must be unique. */
  name: _propTypes.default.string.isRequired,

  /** The label of the field. */
  label: _propTypes.default.string.isRequired,

  /** Prepopulate the default value. */
  checked: _propTypes.default.bool,

  /** The function to propogate changes. */
  onChange: _propTypes.default.func,

  /** Set if this field should be required. */
  required: _propTypes.default.bool,

  /** Set if this field should be disabled. */
  disabled: _propTypes.default.bool
};
cov_2oowdpgmh5.s[2]++;
FormCheckboxComponent.defaultProps = {};
cov_2oowdpgmh5.s[3]++;

var styles = function styles(theme) {
  cov_2oowdpgmh5.f[1]++;
  cov_2oowdpgmh5.s[4]++;
  return {
    root: {}
  };
};

var FormCheckbox = (cov_2oowdpgmh5.s[5]++, (0, _withStyles.default)(styles)(FormCheckboxComponent));
exports.FormCheckbox = FormCheckbox;